export default __webpack_public_path__ + "static/media/greenlabel-up.9f1c9599.png";